import React from "react";

/* eslint-disable max-len */
import PropTypes from 'prop-types';

var SeeOnWallIcon = function SeeOnWallIcon(_ref) {
  var className = _ref.className,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 24 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 24 : _ref$width,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#444749' : _ref$fill;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: width,
    height: height,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.94302 5L3.49111 2.5H20.5283L18.0764 5L18.7766 5.71394L21.4967 2.94049C21.4991 2.96 21.5002 2.97986 21.5002 3V20.4902L19.058 18L18.3578 18.7139L21.0835 21.4931C21.0564 21.4976 21.0286 21.5 21.0002 21.5H3.00024C2.97163 21.5 2.94358 21.4976 2.91628 21.493L5.64186 18.7139L4.94165 18L2.50024 20.4893V3C2.50024 2.97399 2.50223 2.94844 2.50606 2.92351L5.24281 5.71394L5.94302 5ZM1.00024 3C1.00024 1.89543 1.89567 1 3.00024 1H21.0002C22.1048 1 23.0002 1.89543 23.0002 3V21C23.0002 22.1046 22.1048 23 21.0002 23H3.00024C1.89567 23 1.00024 22.1046 1.00024 21V3ZM10.0002 14V10H14.0002V14H10.0002ZM8.00024 9C8.00024 8.44772 8.44796 8 9.00024 8H15.0002C15.5525 8 16.0002 8.44772 16.0002 9V15C16.0002 15.5523 15.5525 16 15.0002 16H9.00024C8.44796 16 8.00024 15.5523 8.00024 15V9Z",
    fill: fill
  }));
};

SeeOnWallIcon.propTypes = {
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string,
  fill: PropTypes.string
};
export default SeeOnWallIcon;